import { rem } from 'polished'
import styled from 'styled-components'

export const Divider = styled.hr`
  border: none;
  border-top: 1px solid ${props => props.theme.palette.neutral.default.six};
  margin: ${rem(4)} 0;
`
